<script setup>
import { computed } from 'vue';
import { Radar } from 'vue-chartjs';
import {
  Chart as ChartJS, Title, Tooltip, Legend,
  RadialLinearScale, PointElement, LineElement, Filler
} from 'chart.js';

ChartJS.register(Title, Tooltip, Legend, RadialLinearScale, PointElement, LineElement, Filler);

const props = defineProps({
  itemLabels: { 
    type: Array,
    required: true
  },
  // 본인(학생용) 또는 우리 학급(학급용)
  ourClassPercentages: {
    type: Array,
    default: () => []
  },
  // 학교 평균 — 넘기면 두 번째 계열로 함께 그린다
  schoolPercentages: {
    type: Array,
    default: () => []
  },
  chartHeight: {
    type: String,
    default: '280px'
  }
});

const MY_COLOR = '#E469A7';
const SCHOOL_COLOR = '#1F4FD8';

const chartData = computed(() => {
  const datasets = [
    {
      data: props.ourClassPercentages,
      backgroundColor: 'rgba(228, 105, 167, 0.1)',
      borderColor: MY_COLOR,
      borderWidth: 2,
      pointBackgroundColor: MY_COLOR,
      pointBorderColor: MY_COLOR,
      pointRadius: 3,
      fill: true,
    }
  ];

  if (props.schoolPercentages?.length) {
    datasets.push({
      data: props.schoolPercentages,
      backgroundColor: 'rgba(31, 79, 216, 0.08)',
      borderColor: SCHOOL_COLOR,
      borderWidth: 2,
      pointBackgroundColor: SCHOOL_COLOR,
      pointBorderColor: SCHOOL_COLOR,
      pointRadius: 3,
      fill: true,
    });
  }

  return { labels: props.itemLabels, datasets };
});

const chartOptions = computed(() => ({
  responsive: true,
  maintainAspectRatio: false, 
  layout: {
    padding: { left: 10, right: 10, top: 0, bottom: 0 }
  },
  scales: {
    r: {
      angleLines: { color: '#ccc', display: true },
      grid: {
        color: '#ccc',
        display: true,
        lineWidth: 2,     
      },
      pointLabels: { display: false },
      min: -25,
      max: 100,
      ticks: { 
        display: false,
        stepSize: 25, 
      },      
    },
  },
  plugins: {
    legend: { display: false },
    tooltip: { display: false, enabled: false}
  },
}));
</script>

<template>    
  <div :style="{height: chartHeight, width:chartHeight}" class="chart">
      <ul>
        <li>100%</li>
        <li>75%</li>
        <li>50%</li>
        <li>25%</li>
        <li>0%</li>
      </ul>
      <Radar :data="chartData" :options="chartOptions"></Radar>
  </div>    
</template>

<style lang="scss" scoped>
.chart {
  position: relative;
  z-index: 1;
  ul {
    position: absolute;
    right: -45px;
    display: flex;
    flex-direction: column;
    gap: 2px;
    line-height: 1.5;
    font-size: 1rem;
    color: #ABAEB9;
    text-align: right;
    z-index: -1;
    li {
      position: relative;
      &::before {
        content: '';
        position: absolute;
        left: -140px;
        bottom: 50%;
        transform: translateY(-50%);
        width: 130px;
        border-top: 2px dashed #E9E9E9;       
      }
    }
  }
  &::after {
    content: "";   
    width: 36px;
    height: 36px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%) rotate(45deg);
    background-color: #E469A71A;
  }
}
</style>